<template>
    <!-- TW Snippet Start v2.0+ -->
    <div class="relative bg-indigo-600">
        <div class="max-w-7xl mx-auto py-1 px-1">
            <div class="pr-16 text-center sm:px-16">
                <p class="font-medium text-white">
                    <span class="">
                      Zprávy v této složce budou odstraněny po 30ti dnech.
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessagesTableTrashWarning"
}
</script>

<style scoped>

</style>
